module.exports = __webpack_public_path__ + "static/img/1.343c4521.jpg";